module.exports = __webpack_public_path__ + "290c284c6e2803855349b89fe46b1d4f.svg";